<template>
  <!-- public enum ReportStatus
    {
        Pending = 1,
        Approved = 2,
        Rejected = 3
    } -->

  <!-- public enum ReportType
    {
        Image = 1,
        Comment = 2,
        CommentThread = 3,
        Video = 4,
        LastGreeting = 5,
        Deceased = 6
    } -->
  <div>
    <v-dialog
      class="rounded-xl"
      v-model="showResolveReportModel"
      persistent
      max-width="400px"
    >
      <v-card style="
                width: 100%;
                box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05) !important;
                border-radius: 12px;
              ">
        <v-card-title class="d-flex justify-space-between">
          <span class="gc-text-h6"
            >{{ lang.actions.report }} -
            <span
              :class="{
                'red--text': currentReportMode.status == 3,
                'green--text': currentReportMode.status == 2,
              }"
            >
              {{
                currentReportMode.status == 2
                  ? lang.actions.accept
                  : lang.actions.decline
              }}
            </span>
          </span>
          <v-icon @click="closeResolveReportModal()">mdi-close</v-icon>
        </v-card-title>
        <v-card-text class="pb-0 mb-4">
          <v-form ref="reportForm">
            <v-textarea
              v-model="statusComment"
              :placeholder="lang.fields.reportComment"
              :rules="[rules.required]"
            ></v-textarea>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small class="btn-bg" elevation="0" @click="resolveReport()">
            {{ lang.actions.save }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-row class="page-title-container">
      <v-col class="col-12">
        <h2 class="page-title">{{ lang.menuLinks.reports }}</h2>
      </v-col>
      <v-col class="col-12">
        <v-select
          :items="reportStatuses"
          @change="getReports()"
          v-model="reportStatus"
          outlined
        ></v-select>
      </v-col>
      <v-col class="col-12">
        <v-card>
          <v-tabs v-model="tab" color="primary" align-tabs="center">
            <v-tab>
              <span class="reports-count" v-if="deceasedReports">{{
                deceasedReports
              }}</span
              >{{ lang.reports.Deceased }}</v-tab
            >
            <v-tab
              ><span class="reports-count" v-if="imageReports">{{
                imageReports
              }}</span
              >{{ lang.reports.Images }}</v-tab
            >
            <v-tab
              ><span class="reports-count" v-if="videoReports">{{
                videoReports
              }}</span
              >{{ lang.reports.Videos }}</v-tab
            >
            <v-tab
              ><span class="reports-count" v-if="lastGreetingReports">{{
                lastGreetingReports
              }}</span
              >{{ lang.reports.LastGreeting }}</v-tab
            >
            <v-tab
              ><span class="reports-count" v-if="commentReports">{{
                commentReports
              }}</span
              >{{ lang.reports.Comments }}</v-tab
            >
            <v-tab
              ><span class="reports-count" v-if="threadReports">{{
                threadReports
              }}</span
              >{{ lang.reports.CommentThreads }}</v-tab
            >
          </v-tabs>
          <v-window v-model="tab">
            <v-window-item>
              <v-container fluid>
                <v-row>
                  <v-col
                    class="col-12 col-sm-4 col-md-3"
                    v-for="(el, index) in reportedData(6)"
                    :key="index"
                  >
                    <v-card elevation="2" class="with-top-border">
                      <v-card-title class="mb-0 d-flex flex-column align-start">
                        <p class="caption mb-0 black--text">
                          {{ lang.reports.Reported }}
                        </p>
                        <p class="caption mb-0 grey--text">
                          {{ el.entityId
                          }}<v-icon
                            class="ml-4 cursor-pointer"
                            @click="copyText(el.entityId, 6)"
                            >mdi-eye</v-icon
                          >
                        </p>
                      </v-card-title>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
            </v-window-item>

            <v-window-item>
              <v-container fluid>
                <v-row>
                  <v-col
                    class="col-12 col-sm-4 col-md-3"
                    v-for="(el, index) in reportedData(1)"
                    :key="index"
                  >
                    <v-card elevation="2" class="with-top-border">
                      <v-card-title class="mb-0 d-flex flex-column align-start">
                        <p class="caption mb-0 black--text">
                          {{ lang.reports.Reported }}
                        </p>
                        <p class="caption mb-0 grey--text">
                          {{ el.entityId
                          }}<v-icon
                            class="ml-4 cursor-pointer"
                            @click="copyText(el.entityId, 1)"
                            >mdi-eye</v-icon
                          >
                        </p>
                      </v-card-title>
                    </v-card>
                  </v-col>
                  <!-- <v-col
                    class="col-12 col-sm-4 col-md-3"
                    v-for="(el, index) in reportedData(1)"
                    :key="index"
                  >
                    <v-card
                      elevation="2"
                      class="with-top-border"
                      :class="{
                        accepted: index % 2 == 0,
                        rejected: index % 2 != 0,
                      }"
                    >
                      <v-img
                        src="https://cdn.vuetifyjs.com/images/cards/sunshine.jpg"
                        height="200px"
                      ></v-img>
                      <v-card-title
                        class="mb-0 d-flex flex-column align-start pb-0"
                      >
                        <p class="caption mb-0 black--text">ID</p>
                        <p class="caption mb-0 grey--text">
                          {{ el.entityId
                          }}<v-icon
                            class="ml-2 cursor-pointer"
                            @click="copyText(el.entityId, 1)"
                            >mdi-content-copy</v-icon
                          >
                        </p>
                      </v-card-title>
                      <v-card-title class="mb-6 d-flex flex-column align-start">
                        <p class="caption mb-0 black--text">
                          {{ lang.reports.ReportedBy }}
                        </p>
                        Veljko Popovic
                        <p class="caption mb-0 grey--text">v@maiilinator.com</p>
                      </v-card-title>

                      <v-card-subtitle class="pb-0">
                        <strong>{{ lang.reports.Reason }}</strong>
                        <div>1,000 miles of wonder</div>
                      </v-card-subtitle>
                      <v-card-subtitle class="pt-2 pb-0">
                        <strong>{{ lang.reports.OtherReason }}</strong>
                        <div>1,000 miles of wonder</div></v-card-subtitle
                      >
                      <v-card-subtitle class="pt-2">
                        <strong>{{ lang.reports.Status }}</strong>

                        <span
                          v-if="index % 5"
                          class="green--text font-weight-bold font-italic"
                        >
                          Accepted</span
                        >
                        <span
                          v-else
                          class="red--text font-weight-bold font-italic"
                        >
                          Rejected</span
                        >

                        <div v-if="index % 5" class="grey--text font-italic">
                          Accepted due to some reason
                        </div>
                        <div v-else class="grey--text font-italic">
                          Rejected due to some reason
                        </div>
                      </v-card-subtitle>
                      <v-card-actions>
                        <v-btn color="green lighten-2" text>
                          {{ lang.actions.accept }}
                        </v-btn>

                        <v-spacer></v-spacer>

                        <v-btn color="red lighten-2" text>
                          {{ lang.actions.decline }}
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-col> -->
                </v-row>
              </v-container>
            </v-window-item>

            <v-window-item>
              <v-container fluid>
                <v-row>
                  <v-col
                    class="col-12 col-sm-4 col-md-3"
                    v-for="(el, index) in reportedData(4)"
                    :key="index"
                  >
                    <v-card elevation="2" class="with-top-border">
                      <v-card-title class="mb-0 d-flex flex-column align-start">
                        <p class="caption mb-0 black--text">
                          {{ lang.reports.Reported }}
                        </p>
                        <p class="caption mb-0 grey--text">
                          {{ el.entityId
                          }}<v-icon
                            class="ml-4 cursor-pointer"
                            @click="copyText(el.entityId, 4)"
                            >mdi-eye</v-icon
                          >
                        </p>
                      </v-card-title>
                    </v-card>
                  </v-col>
                  <!-- <v-col
                    class="col-12 col-sm-4 col-md-3"
                    v-for="(el, index) in reportedData(4)"
                    :key="index"
                  >
                    <v-card
                      elevation="2"
                      class="with-top-border"
                      :class="{
                        accepted: index % 2 == 0,
                        rejected: index % 2 != 0,
                      }"
                    >
                      <video style="width: 100%" height="200px" controls>
                        <source
                          src="http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4"
                          type="video/mp4"
                        />
                        Your browser does not support the video tag.
                      </video>
                      <v-card-title
                        class="mb-0 d-flex flex-column align-start pb-0"
                      >
                        <p class="caption mb-0 black--text">ID</p>
                        <p class="caption mb-0 grey--text">
                          {{ el.entityId
                          }}<v-icon
                            class="ml-2 cursor-pointer"
                            @click="copyText(el.entityId, 4)"
                            >mdi-content-copy</v-icon
                          >
                        </p>
                      </v-card-title>
                      <v-card-title class="mb-6 d-flex flex-column align-start">
                        <p class="caption mb-0 black--text">
                          {{ lang.reports.ReportedBy }}
                        </p>
                        Veljko Popovic
                        <p class="caption mb-0 grey--text">v@maiilinator.com</p>
                      </v-card-title>

                      <v-card-subtitle class="pb-0">
                        <strong>{{ lang.reports.Reason }}</strong>
                        <div>1,000 miles of wonder</div>
                      </v-card-subtitle>
                      <v-card-subtitle class="pt-2 pb-0">
                        <strong>{{ lang.reports.OtherReason }}</strong>
                        <div>1,000 miles of wonder</div></v-card-subtitle
                      >
                      <v-card-subtitle class="pt-2">
                        <strong>{{ lang.reports.Status }}</strong>

                        <span
                          v-if="index % 5"
                          class="green--text font-weight-bold font-italic"
                        >
                          Accepted</span
                        >
                        <span
                          v-else
                          class="red--text font-weight-bold font-italic"
                        >
                          Rejected</span
                        >

                        <div v-if="index % 5" class="grey--text font-italic">
                          Accepted due to some reason
                        </div>
                        <div v-else class="grey--text font-italic">
                          Rejected due to some reason
                        </div>
                      </v-card-subtitle>

                      <v-card-actions>
                        <v-btn color="green lighten-2" text>
                          {{ lang.actions.accept }}
                        </v-btn>

                        <v-spacer></v-spacer>

                        <v-btn color="red lighten-2" text>
                          {{ lang.actions.decline }}
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-col> -->
                </v-row>
              </v-container>
            </v-window-item>

            <v-window-item>
              <v-container fluid>
                <v-row>
                  <v-col
                    class="col-12 col-sm-4 col-md-3"
                    v-for="(el, index) in reportedData(5)"
                    :key="index"
                  >
                    <v-card elevation="2" class="with-top-border">
                      <v-card-title class="mb-0 d-flex flex-column align-start">
                        <p class="caption mb-0 black--text">
                          {{ lang.reports.Reported }}
                        </p>
                        <p class="caption mb-0 grey--text">
                          {{ el.entityId
                          }}<v-icon
                            class="ml-4 cursor-pointer"
                            @click="copyText(el.entityId, 5)"
                            >mdi-eye</v-icon
                          >
                        </p>
                      </v-card-title>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
            </v-window-item>

            <v-window-item>
              <v-container fluid>
                <v-row>
                  <v-col
                    class="col-12 col-sm-4 col-md-3"
                    v-for="(el, index) in reportedData(2)"
                    :key="index"
                  >
                    <v-card elevation="2" class="with-top-border">
                      <v-card-title class="mb-0 d-flex flex-column align-start">
                        <p class="caption mb-0 black--text">
                          {{ lang.reports.Reported }}
                        </p>
                        <p class="caption mb-0 grey--text">
                          {{ el.entityId
                          }}<v-icon
                            class="ml-4 cursor-pointer"
                            @click="copyText(el.entityId, 2)"
                            >mdi-eye</v-icon
                          >
                        </p>
                      </v-card-title>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
            </v-window-item>

            <v-window-item>
              <v-container fluid>
                <v-row>
                  <v-col
                    class="col-12 col-sm-4 col-md-3"
                    v-for="(el, index) in reportedData(3)"
                    :key="index"
                  >
                    <v-card elevation="2" class="with-top-border">
                      <v-card-title class="mb-0 d-flex flex-column align-start">
                        <p class="caption mb-0 black--text">
                          {{ lang.reports.Reported }}
                        </p>
                        <p class="caption mb-0 grey--text">
                          {{ el.entityId
                          }}<v-icon
                            class="ml-4 cursor-pointer"
                            @click="copyText(el.entityId, 3)"
                            >mdi-eye</v-icon
                          >
                        </p>
                      </v-card-title>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
            </v-window-item>
          </v-window>
        </v-card>
      </v-col>
      <v-col class="col-12">
        <v-dialog
          v-model="selectedReport"
          fullscreen
          :scrim="false"
          transition="dialog-bottom-transition"
        >
          <v-card class="dialog-container">
            <v-toolbar dark color="primary" elevation="0">
              <v-btn icon dark @click="selectedReport = false" :ripple="false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <!-- deceased -->
            <div v-if="selectedReportType == 6">
              <v-col
                class="col-12 col-sm-4 col-md-3"
                v-for="(el, index) in reportInfo"
                :key="index"
              >
                <v-card
                  v-if="el.reportedDeceased"
                  elevation="2"
                  class="with-top-border"
                  :class="{
                    accepted: el.status == 2,
                    rejected: el.status == 3,
                  }"
                >
                  <v-card-title class="mb-0 d-flex flex-column align-start">
                    <p class="caption mb-0 black--text">
                      {{ lang.reports.Reported }}
                    </p>
                    {{ el.reportedDeceased.firstName }}
                    {{ el.reportedDeceased.lastName }}
                    <p class="caption mb-0 grey--text">
                      {{ el.entityId }}
                    </p>
                  </v-card-title>
                  <v-card-title
                    class="mb-6 pt-0 d-flex flex-column align-start"
                  >
                    <p class="caption mb-0 black--text">
                      {{ lang.reports.ReportedBy }}
                    </p>
                    {{ el.reportedBy }}
                    <p class="caption mb-0 grey--text">
                      {{ el.reportedByEmail }}
                    </p>
                  </v-card-title>

                  <v-card-subtitle class="pb-0">
                    <strong>{{ lang.reports.Reason }}</strong>
                    <div>{{ el.reason }}</div>
                  </v-card-subtitle>
                  <v-card-subtitle class="pt-2 pb-0" v-if="el.otherReason">
                    <strong>{{ lang.reports.OtherReason }}</strong>
                    <div>{{ el.otherReason }}</div></v-card-subtitle
                  >
                  <v-card-subtitle
                    class="pt-2"
                    v-if="[2, 3].includes(el.status)"
                  >
                    <strong>{{ lang.reports.Status }}</strong>

                    <span
                      v-if="el.status == 2"
                      class="green--text font-weight-bold font-italic"
                    >
                      {{ lang.reports.Approved }}</span
                    >
                    <span v-else class="red--text font-weight-bold font-italic">
                      {{ lang.reports.Rejected }}</span
                    >

                    <div class="grey--text font-italic">
                      {{ el.statusComment }}
                    </div>
                  </v-card-subtitle>
                  <v-card-actions class="mt-4" v-if="el.status == 1">
                    <v-btn
                      color="green lighten-2"
                      text
                      @click="resolveReportModal(el, 2)"
                    >
                      {{ lang.actions.accept }}
                    </v-btn>

                    <v-spacer></v-spacer>

                    <v-btn
                      color="red lighten-2"
                      text
                      @click="resolveReportModal(el, 3)"
                    >
                      {{ lang.actions.decline }}
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </div>

            <!-- image -->
            <div v-if="selectedReportType == 1">
              <v-col
                class="col-12 col-sm-4 col-md-3"
                v-for="(el, index) in reportInfo"
                :key="index"
              >
                <v-card
                  v-if="el.reportedImage"
                  elevation="2"
                  class="with-top-border"
                  :class="{
                    accepted: el.status == 2,
                    rejected: el.status == 3,
                  }"
                >
                  <!-- el.reportedImage.name -->
                  <!-- todo -->
                  <v-img
                    :src="el.reportedImage.imageUrl"
                    height="200px"
                  ></v-img>
                  <v-card-title class="mb-0 d-flex flex-column align-start">
                    <p class="caption mb-0 black--text">
                      {{ lang.reports.Reported }}
                    </p>
                    {{ el.reportedImage.firstName }}
                    {{ el.reportedImage.lastName }}
                    <p class="caption mb-0 grey--text">
                      {{ el.entityId }}
                    </p>
                  </v-card-title>
                  <v-card-title
                    class="mb-6 pt-0 d-flex flex-column align-start"
                  >
                    <p class="caption mb-0 black--text">
                      {{ lang.reports.ReportedBy }}
                    </p>
                    {{ el.reportedBy }}
                    <p class="caption mb-0 grey--text">
                      {{ el.reportedByEmail }}
                    </p>
                  </v-card-title>

                  <!-- <v-card-subtitle class="pb-0">
                    <strong>{{ lang.reports.Reason }}</strong>
                    <div>1,000 miles of wonder</div>
                  </v-card-subtitle> -->
                  <v-card-subtitle class="pb-0">
                    <strong>{{ lang.reports.Reason }}</strong>
                    <div>{{ el.reason }}</div>
                  </v-card-subtitle>
                  <v-card-subtitle class="pt-2 pb-0" v-if="el.otherReason">
                    <strong>{{ lang.reports.OtherReason }}</strong>
                    <div>{{ el.otherReason }}</div></v-card-subtitle
                  >
                  <v-card-subtitle
                    class="pt-2"
                    v-if="[2, 3].includes(el.status)"
                  >
                    <strong>{{ lang.reports.Status }}</strong>

                    <span
                      v-if="el.status == 2"
                      class="green--text font-weight-bold font-italic"
                    >
                      {{ lang.reports.Approved }}</span
                    >
                    <span v-else class="red--text font-weight-bold font-italic">
                      {{ lang.reports.Rejected }}</span
                    >

                    <div class="grey--text font-italic">
                      {{ el.statusComment }}
                    </div>
                  </v-card-subtitle>
                  <v-card-actions class="mt-4" v-if="el.status == 1">
                    <v-btn
                      color="green lighten-2"
                      text
                      @click="resolveReportModal(el, 2)"
                    >
                      {{ lang.actions.accept }}
                    </v-btn>

                    <v-spacer></v-spacer>

                    <v-btn
                      color="red lighten-2"
                      text
                      @click="resolveReportModal(el, 3)"
                    >
                      {{ lang.actions.decline }}
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </div>

            <!-- video -->
            <div v-if="selectedReportType == 4">
              <v-col
                class="col-12 col-sm-4 col-md-3"
                v-for="(el, index) in reportInfo"
                :key="index"
              >
                <v-card
                  v-if="el.reportedVideo"
                  elevation="2"
                  class="with-top-border"
                  :class="{
                    accepted: el.status == 2,
                    rejected: el.status == 3,
                  }"
                >
                  <video
                    style="width: 100%"
                    height="200px"
                    controls
                    :key="el.reportedVideo.videoUrl"
                    controlsList="nodownload"
                    v-if="el.reportedVideo.videoUrl"
                  >
                    <source :src="el.reportedVideo.videoUrl" type="video/mp4" />
                    <source
                      :src="el.reportedVideo.videoUrl"
                      type="video/webm"
                    />
                    <source :src="el.reportedVideo.videoUrl" type="video/ogg" />
                    <source
                      :src="el.reportedVideo.videoUrl"
                      type="video/quicktime"
                    />
                    <source
                      :src="el.reportedVideo.videoUrl"
                      type="video/x-msvideo"
                    />
                    <source
                      :src="el.reportedVideo.videoUrl"
                      type="video/x-matroska"
                    />
                    Your browser does not support the video tag.
                  </video>
                  <v-card-title class="mb-0 d-flex flex-column align-start">
                    <p class="caption mb-0 black--text">
                      {{ lang.reports.Reported }}
                    </p>
                    {{ el.reportedVideo.firstName }}
                    {{ el.reportedVideo.lastName }}
                    <p class="caption mb-0 grey--text">
                      {{ el.entityId }}
                    </p>
                  </v-card-title>
                  <v-card-title
                    class="mb-6 pt-0 d-flex flex-column align-start"
                  >
                    <p class="caption mb-0 black--text">
                      {{ lang.reports.ReportedBy }}
                    </p>
                    {{ el.reportedBy }}
                    <p class="caption mb-0 grey--text">
                      {{ el.reportedByEmail }}
                    </p>
                  </v-card-title>

                  <v-card-subtitle class="pb-0">
                    <strong>{{ lang.reports.Reason }}</strong>
                    <div>{{ el.reason }}</div>
                  </v-card-subtitle>
                  <v-card-subtitle class="pt-2 pb-0" v-if="el.otherReason">
                    <strong>{{ lang.reports.OtherReason }}</strong>
                    <div>{{ el.otherReason }}</div></v-card-subtitle
                  >
                  <v-card-subtitle
                    class="pt-2"
                    v-if="[2, 3].includes(el.status)"
                  >
                    <strong>{{ lang.reports.Status }}</strong>

                    <span
                      v-if="el.status == 2"
                      class="green--text font-weight-bold font-italic"
                    >
                      {{ lang.reports.Approved }}</span
                    >
                    <span v-else class="red--text font-weight-bold font-italic">
                      {{ lang.reports.Rejected }}</span
                    >

                    <div class="grey--text font-italic">
                      {{ el.statusComment }}
                    </div>
                  </v-card-subtitle>
                  <v-card-actions class="mt-4" v-if="el.status == 1">
                    <v-btn
                      color="green lighten-2"
                      text
                      @click="resolveReportModal(el, 2)"
                    >
                      {{ lang.actions.accept }}
                    </v-btn>

                    <v-spacer></v-spacer>

                    <v-btn
                      color="red lighten-2"
                      text
                      @click="resolveReportModal(el, 3)"
                    >
                      {{ lang.actions.decline }}
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </div>

            <!-- last greetings -->
            <div v-if="selectedReportType == 5">
              <v-col
                class="col-12 col-sm-4 col-md-3"
                v-for="(el, index) in reportInfo"
                :key="index"
              >
                <v-card
                  v-if="el.reportedLastGreeting"
                  elevation="2"
                  class="with-top-border"
                  :class="{
                    accepted: el.status == 2,
                    rejected: el.status == 3,
                  }"
                >
                  <v-card-title class="mb-0 d-flex flex-column align-start">
                    <p class="caption mb-0 black--text">
                      {{ lang.reports.Reported }}
                    </p>
                    <p class="caption mb-0 grey--text">
                      {{ el.entityId }}
                    </p>
                  </v-card-title>

                  <v-card-subtitle class="pb-4 pt-2">
                    <strong>{{ lang.reports.LastGreetingContent }}</strong>
                    <div>{{ el.reportedLastGreeting.note }}</div>
                  </v-card-subtitle>

                  <v-card-title
                    class="mb-6 pt-0 d-flex flex-column align-start"
                  >
                    <p class="caption mb-0 black--text">
                      {{ lang.reports.ReportedBy }}
                    </p>
                    {{ el.reportedBy }}
                    <p class="caption mb-0 grey--text">
                      {{ el.reportedByEmail }}
                    </p>
                  </v-card-title>
                  <v-card-subtitle class="pb-0">
                    <strong>{{ lang.reports.Reason }}</strong>
                    <div>{{ el.reason }}</div>
                  </v-card-subtitle>
                  <v-card-subtitle class="pt-2 pb-0" v-if="el.otherReason">
                    <strong>{{ lang.reports.OtherReason }}</strong>
                    <div>{{ el.otherReason }}</div></v-card-subtitle
                  >
                  <v-card-subtitle
                    class="pt-2"
                    v-if="[2, 3].includes(el.status)"
                  >
                    <strong>{{ lang.reports.Status }}</strong>

                    <span
                      v-if="el.status == 2"
                      class="green--text font-weight-bold font-italic"
                    >
                      {{ lang.reports.Approved }}</span
                    >
                    <span v-else class="red--text font-weight-bold font-italic">
                      {{ lang.reports.Rejected }}</span
                    >

                    <div class="grey--text font-italic">
                      {{ el.statusComment }}
                    </div>
                  </v-card-subtitle>
                  <v-card-actions class="mt-4" v-if="el.status == 1">
                    <v-btn
                      color="green lighten-2"
                      text
                      @click="resolveReportModal(el, 2)"
                    >
                      {{ lang.actions.accept }}
                    </v-btn>

                    <v-spacer></v-spacer>

                    <v-btn
                      color="red lighten-2"
                      text
                      @click="resolveReportModal(el, 3)"
                    >
                      {{ lang.actions.decline }}
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </div>

            <!-- comments -->
            <div v-if="selectedReportType == 2">
              <v-col
                class="col-12 col-sm-4 col-md-3"
                v-for="(el, index) in reportInfo"
                :key="index"
              >
                <v-card
                  v-if="el.reportedComment"
                  elevation="2"
                  class="with-top-border"
                  :class="{
                    accepted: el.status == 2,
                    rejected: el.status == 3,
                  }"
                >
                  <v-card-title class="mb-0 d-flex flex-column align-start">
                    <p class="caption mb-0 black--text">
                      {{ lang.reports.Reported }}
                    </p>
                    <p class="caption mb-0 grey--text">
                      {{ el.entityId }}
                    </p>
                  </v-card-title>

                  <v-card-subtitle class="pb-4 pt-2">
                    <strong>{{ lang.reports.CommentContent }}</strong>
                    <div>{{ el.reportedComment.text }}</div>
                  </v-card-subtitle>

                  <v-card-title
                    class="mb-6 pt-0 d-flex flex-column align-start"
                  >
                    <p class="caption mb-0 black--text">
                      {{ lang.reports.ReportedBy }}
                    </p>
                    {{ el.reportedBy }}
                    <p class="caption mb-0 grey--text">
                      {{ el.reportedByEmail }}
                    </p>
                  </v-card-title>
                  <v-card-subtitle class="pb-0">
                    <strong>{{ lang.reports.Reason }}</strong>
                    <div>{{ el.reason }}</div>
                  </v-card-subtitle>
                  <v-card-subtitle class="pt-2 pb-0" v-if="el.otherReason">
                    <strong>{{ lang.reports.OtherReason }}</strong>
                    <div>{{ el.otherReason }}</div></v-card-subtitle
                  >
                  <v-card-subtitle
                    class="pt-2"
                    v-if="[2, 3].includes(el.status)"
                  >
                    <strong>{{ lang.reports.Status }}</strong>

                    <span
                      v-if="el.status == 2"
                      class="green--text font-weight-bold font-italic"
                    >
                      {{ lang.reports.Approved }}</span
                    >
                    <span v-else class="red--text font-weight-bold font-italic">
                      {{ lang.reports.Rejected }}</span
                    >

                    <div class="grey--text font-italic">
                      {{ el.statusComment }}
                    </div>
                  </v-card-subtitle>
                  <v-card-actions class="mt-4" v-if="el.status == 1">
                    <v-btn
                      color="green lighten-2"
                      text
                      @click="resolveReportModal(el, 2)"
                    >
                      {{ lang.actions.accept }}
                    </v-btn>

                    <v-spacer></v-spacer>

                    <v-btn
                      color="red lighten-2"
                      text
                      @click="resolveReportModal(el, 3)"
                    >
                      {{ lang.actions.decline }}
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </div>

            <!-- comment threads -->
            <div v-if="selectedReportType == 3">
              <v-col
                class="col-12 col-sm-4 col-md-3"
                v-for="(el, index) in reportInfo"
                :key="index"
              >
                <v-card
                  v-if="el.reportedComment"
                  elevation="2"
                  class="with-top-border"
                  :class="{
                    accepted: el.status == 2,
                    rejected: el.status == 3,
                  }"
                >
                  <v-card-title class="mb-0 d-flex flex-column align-start">
                    <p class="caption mb-0 black--text">
                      {{ lang.reports.Reported }}
                    </p>
                    <p class="caption mb-0 grey--text">
                      {{ el.entityId }}
                    </p>
                  </v-card-title>

                  <v-card-subtitle class="pb-4 pt-2">
                    <strong>{{ lang.reports.CommentThreadContent }}</strong>
                    <div>{{ el.reportedComment.text }}</div>
                  </v-card-subtitle>

                  <v-card-title
                    class="mb-6 pt-0 d-flex flex-column align-start"
                  >
                    <p class="caption mb-0 black--text">
                      {{ lang.reports.ReportedBy }}
                    </p>
                    {{ el.reportedBy }}
                    <p class="caption mb-0 grey--text">
                      {{ el.reportedByEmail }}
                    </p>
                  </v-card-title>
                  <v-card-subtitle class="pb-0">
                    <strong>{{ lang.reports.Reason }}</strong>
                    <div>{{ el.reason }}</div>
                  </v-card-subtitle>
                  <v-card-subtitle class="pt-2 pb-0" v-if="el.otherReason">
                    <strong>{{ lang.reports.OtherReason }}</strong>
                    <div>{{ el.otherReason }}</div></v-card-subtitle
                  >
                  <v-card-subtitle
                    class="pt-2"
                    v-if="[2, 3].includes(el.status)"
                  >
                    <strong>{{ lang.reports.Status }}</strong>

                    <span
                      v-if="el.status == 2"
                      class="green--text font-weight-bold font-italic"
                    >
                      {{ lang.reports.Approved }}</span
                    >
                    <span v-else class="red--text font-weight-bold font-italic">
                      {{ lang.reports.Rejected }}</span
                    >

                    <div class="grey--text font-italic">
                      {{ el.statusComment }}
                    </div>
                  </v-card-subtitle>
                  <v-card-actions class="mt-4" v-if="el.status == 1">
                    <v-btn
                      color="green lighten-2"
                      text
                      @click="resolveReportModal(el, 2)"
                    >
                      {{ lang.actions.accept }}
                    </v-btn>

                    <v-spacer></v-spacer>

                    <v-btn
                      color="red lighten-2"
                      text
                      @click="resolveReportModal(el, 3)"
                    >
                      {{ lang.actions.decline }}
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </div>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
export default {
  data() {
    return {
      tab: 0,
      reportStatus: 1,
      selectedReport: null,
      selectedReportType: null,
      currentReportMode: {},
      showResolveReportModel: false,
      statusComment: "",
    };
  },
  computed: {
    ...mapGetters(["rules"]),
    ...mapGetters("user", ["currentUser"]),
    ...mapGetters("reports", ["reports", "reportInfo"]),
    deceasedReports() {
      return this.reports.filter((el) => el.type == 6).length;
    },
    imageReports() {
      return this.reports.filter((el) => el.type == 1).length;
    },
    videoReports() {
      return this.reports.filter((el) => el.type == 4).length;
    },
    lastGreetingReports() {
      return this.reports.filter((el) => el.type == 5).length;
    },
    commentReports() {
      return this.reports.filter((el) => el.type == 2).length;
    },
    threadReports() {
      return this.reports.filter((el) => el.type == 3).length;
    },
    lang() {
      return this.$store.state.langObj || {};
    },
    reportStatuses() {
      return [
        {
          text: this.lang.reports.Pending,
          value: 1,
        },
        {
          text: this.lang.reports.Approved,
          value: 2,
        },
        {
          text: this.lang.reports.Rejected,
          value: 3,
        },
      ];
    },
  },
  methods: {
    reportedData(num) {
      return this.reports.filter((el) => el.type == num);
    },
    copyText(copyText, num) {
      this.$store.dispatch("reports/getReportInfo", copyText).then(() => {
        this.selectedReportType = num;
        this.selectedReport = this.reportInfo;
      });
    },
    getReports() {
      // Pending = 1,
      // Approved = 2,
      // Rejected = 3

      // Image = 1,
      // Comment = 2,
      // CommentThread = 3,
      // Video = 4,
      // LastGreeting = 5,
      // Deceased = 6
      this.$store.dispatch("reports/getReports", this.reportStatus);
    },
    resolveReportModal(el, status) {
      this.currentReportMode = { el, status };
      this.showResolveReportModel = true;
    },
    closeResolveReportModal() {
      this.selectedReport = null;
      this.selectedReportType = null;
      this.currentReportMode = {};
      this.showResolveReportModel = false;
      this.statusComment = "";
    },
    resolveReport() {
      // Pending = 1,
      // Approved = 2,
      // Rejected = 3
      if (this.$refs.reportForm.validate()) {
        var obj = {
          id: this.currentReportMode.el.id,
          statusComment: this.statusComment,
          status: this.currentReportMode.status,
          resolvedByUserId: this.currentUser.id,
        };
        this.$store.dispatch("reports/resolveReport", obj).then(() => {
          this.closeResolveReportModal();
          this.getReports();
        });
      }
    },
  },
  mounted() {
    document.title = "Good Casper - Reports";
    this.getReports();
  },
};
</script>

<style lang="scss" scoped>
.reports-count {
  cursor: pointer;
  background: red;
  color: #fff;
  font-size: 8px;
  border-radius: 50%;
  width: 15px;
  aspect-ratio: 1;
  position: absolute;
  top: 6px;
  right: 2px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.with-top-border {
  border-top: 7px solid transparent;
  &.accepted {
    border-top: 7px solid green;
  }
  &.rejected {
    border-top: 7px solid red;
  }
}
</style>